import { getAnalyticsAbExperiments } from '#/utils/analytics/abExperiments/analyticsAbExperiments';
import { getAnalyticsAbExperimentsConcatenatedString } from '#/utils/analytics/abExperiments/getAnalyticsAbExperimentsConcatenatedString';
import { getCookieValue } from '#/utils/cookies';
import {
  getLocalStorageJsonItem,
  setLocalStorageJsonItem,
} from '#/utils/localStorage';

import { getAnalyticsApplicationContextProps } from './getAnalyticsApplicationContextProps';

export function windowDataLayerPush(baseEventData: Record<string, unknown>) {
  const eventData = {
    ...baseEventData,
    ...getAnalyticsApplicationContextProps(),
    experiments: getAnalyticsAbExperimentsConcatenatedString(
      getAnalyticsAbExperiments(),
    ),
  };

  if (getCookieValue('_traceAnalytics')) {
    const trace =
      getLocalStorageJsonItem<Record<string, unknown>[]>('_analyticsTrace') ??
      [];
    trace.push(eventData);
    setLocalStorageJsonItem('_analyticsTrace', trace);
  }

  window.dataLayer.push(eventData);
}
